import { Component, OnInit } from '@angular/core';
import { Session } from 'src/app/models/session';
import { UserService } from 'src/app/services/user.service';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-calificar-consulta',
  templateUrl: './calificar-consulta.component.html',
  styleUrls: ['./calificar-consulta.component.css']
})
export class CalificarConsultaComponent implements OnInit {

  constructor(private session: Session, private service: UserService, private activatedRoute: ActivatedRoute, private toast: ToastrService) { }



  step = 1;
  respuestas = { a: 3, b: 3, c: 3, d: 3, text: "" };
  se_repitio_falla = 1;
  la_unidad_anda_bien = 2;
  
  id;
  ticket;
  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(d=>{
      if(d.id){
        this.id = d.id;
        this.service.getTicketParaCalificar(this.id).subscribe(r=>{
          this.ticket = r;
        },er=>{
          this.toast.error("TICKET NO ENCONTRADO");
        })
      }
    })
    
  }


  confirm(){
    let body = JSON.parse(JSON.stringify(this.respuestas));
    body.text = "La unidad anda bien? : " + (this.la_unidad_anda_bien==1?"NO":"SI" ) + "\n"    + body.text;
    body.text = "Se repitió la falla? : " + (this.se_repitio_falla==1?"NO":"SI" ) + "\n"    + body.text;
    
    this.service.calificarTicket(this.ticket._id, body).subscribe(d=>{
      this.step++;
    }, er=>{
      this.toast.error("ERROR");
    })
    
  }

}
